export default __webpack_public_path__ + "static/media/icon-selo-concluido.3fa5c2f9.svg";